import { render, staticRenderFns } from "./WorkshopDetailsDialog.vue?vue&type=template&id=ed9b0876&"
import script from "./WorkshopDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./WorkshopDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/buttons/ButtonPrimary.vue').default,Modal: require('/home/forge/portal.gradlinc.co.za/releases/20260311091735/components/global/Modal.vue').default})
